export default function filterByMirCashback(_product: unknown): boolean {
    return false;
}
